<template>
  <div class="navicon" @click="toggleNavState(!navOpen)">
    <transition @enter="naviconTextEnter" @leave="naviconTextLeave">
      <span v-if="!navOpen" class="navicon__text" v-html="splitText(openLabel)"
        key="open" ref="naviconOpen" />
      <span v-else class="navicon__text" v-html="splitText(closeLabel)"
        key="close" ref="naviconClose" />
    </transition>
    <i class="navicon__icon" :class="{'nav-open':navOpen}" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ifDefined from '@/tools/ifDefined'

import anime from 'animejs'

export default {
  name: 'AppNavicon',
  data() {
    return {
      openLabel: '',
      closeLabel: ''
    }
  },
  computed: {
    ...mapGetters(['nav', 'navOpen', 'ui'])
  },
  methods: {
    ...mapActions(['toggleNavState']),
    naviconTextEnter(el, done) {
      var count = el.children.length
      var tStart = this.navOpen ? '100%' : '-100%'
      anime.timeline().add({
        targets: el.children,
        duration: 80,
        easing: 'easeOutQuad',
        opacity: [0, 1],
        translateY: [tStart, '0%'],
        delay: function(el, i) {
          return 25 * (count - i)
        },
        complete: function(anim) {
          anim.animatables.forEach(el => {
            el.target.removeAttribute('style')
          })
          done()
        }
      })
    },
    naviconTextLeave(el, done) {
      var count = el.children.length
      var tStart = this.navOpen ? '-100%' : '100%'
      anime.timeline().add({
        targets: el.children,
        duration: 80,
        easing: 'easeOutQuad',
        opacity: 0,
        translateY: tStart,
        delay: function(el, i) {
          return 25 * (count - i)
        },
        complete: function(anim) {
          anim.animatables.forEach(el => {
            el.target.removeAttribute('style')
          })
          done()
        }
      })
    }
  },
  watch: {
    nav(newNav, oldNav) {
      this.openLabel = ifDefined(oldNav.openLabel)
        ? this.openLabel
        : this.ui.nav_open_label
      this.closeLabel = ifDefined(oldNav.closeLabel)
        ? this.openLabel
        : this.ui.nav_close_label
    }
  },
  updated() {},
  mounted() {}
}
</script>
<style>
.navicon__text {
  position: absolute;
  top: 3.8rem;
  right: 8.2rem;
  white-space: nowrap;
  line-height: 1;
}
.navicon__text span {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/partials/AppNavicon.vue